/**
 * `SubsectionForm` `titleSubtitle` strings for Facility Power Readiness subsection cards.
 * On narrow viewports these are hidden by `SubsectionForm` (see `useResponsive` `isSmallScreen`).
 */
export const FACILITY_POWER_SECTION_SUBTITLE =
  'Utility voltage, capacity, IT load, and site description. Attach one-lines or utility details if helpful.';

export const FACILITY_POWER_LARGE_UPS_SUBTITLE =
  'Existing large UPS, redundancy, batteries, runtime, and fire-suppression context.';

export const FACILITY_POWER_DISTRIBUTION_SUBTITLE =
  'IT load voltage, busway vs underfloor feeds, tap boxes, and UPS output.';

export const FACILITY_POWER_ADDITIONAL_SUBTITLE =
  'Extra notes or attachments for facility power readiness.';
